import { StaticSiteAccessLogsDataFallback } from '@/routes/static-site/tabs/access-logs/access-logs-data/access-logs-data-fallback'

export const StaticSiteAccessLogsTabFallback = () => {
  return <StaticSiteAccessLogsDataFallback />
}
